/* global globalData, urlParams, CONTENT, CONTENT_TARGET, ANIMATIONS, animationTime, TYPES, color, loadingBar */

var runningMode = {
  /**
   * Validates objects in runningMode and start initial View.<br/>
   * If no runningMode set with urlParams or nor found, use the mode
   * defined in <i>getDefaultMode</i>.
   * @returns {Promise}
   * <i>false</i> on unvalid content objects. See console output.
   */
  init: function () {
    return new Promise((resolve, reject) => {
      if (!this.validate()) throw new Error("runningMode faild.");

      //get running mode to use
      //if no runningMode set with urlParams or nor found, use the default mode.
      var modeFromUrl = urlParams.data.runningMode;
      if (modeFromUrl === undefined || this[modeFromUrl] === undefined)
        this.mode = this.getDefaultMode();
      else this.mode = this[modeFromUrl];

      //load initial view
      var dataForView = runningMode.mode.startContent.data(); //have to be done before changeContent, because of possible self manipulation
      CONTENT_TARGET.changeContent(
        runningMode.mode.startContent.content,
        dataForView,
        undefined,
        { disableUrlPushState: true }
      );
      resolve();
    });
  },
  /**
   * Validates objects in runningMode
   * @returns {Boolean}
   */
  validate: function () {
    var items = getAllContentFromObject(this);

    for (var i in items) {
      //check if item is valid
      var valid = validateObject(this.MODEL, items[i], i);
      if (valid !== true) {
        console.error(valid);
        return false;
      }
    }
    return true;
  },
  /**
   * Contains the current running mode at runtime.
   * @type undefined|object
   */
  mode: undefined,
  /**
   * Defines the default running Mode.
   * @returns {runningMode.*}
   */
  getDefaultMode: function () {
    return this.WEBSITE;
  },
  /**
   * Model of running mode. Needed for validation.
   */
  MODEL: {
    /**
     * This will be not used to work. Just for document the urlParams for each running mode
     * @type object
     */
    help: {
      params: [
        {
          key: "string",
          value: "string",
        },
      ],
    },
    startContent: {
      content: {},
      data: function () {},
    },
  },
  /**
   * Default running mode for normal web access.
   */
  WEBSITE: {
    help: {
      params: [],
    },
    startContent: {
      content: CONTENT.PARTNER_GROUP, //do not use login cause of loops
      data: function () {
        var viewFromUrl;
        var viewDataFromUrl;

        //session check
        CONTENT.LOGIN.functions
          .checkSession()
          .then(() => {
            CONTENT.LOGIN.functions.loginCb(true);

            //---- deep links ----
            //have to be on the end of this function cause of return
            if (urlParams.data.view !== undefined) {
              viewFromUrl = CONTENT[urlParams.data.view.toUpperCase()];

              if (viewFromUrl !== undefined) {
                delete urlParams.data.view;
                runningMode.WEBSITE.startContent.content = viewFromUrl;
                viewDataFromUrl =
                  Object.keys(urlParams.data).length > 0
                    ? urlParams.data
                    : null;
              }
            }
            //---- deep links end ----

            if (viewFromUrl)
              CONTENT_TARGET.changeContent(viewFromUrl, viewDataFromUrl);
          })
          .catch(() => {
            CONTENT.LOGIN.functions.loginCb(false);
            if (CONTENT_TARGET.currentContent !== CONTENT.LOGIN)
              CONTENT_TARGET.changeContent(CONTENT.LOGIN);
          });
      },
    },
  },
};
